// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orc0yy40YmcalmmMkQI9{background:var(--background-primary-inverted-primary);width:260px;box-shadow:var(--menu-shadow);border-radius:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `orc0yy40YmcalmmMkQI9`
};
export default ___CSS_LOADER_EXPORT___;
